(() => {
  function setup() {
    document.querySelectorAll('.pp-lamp-video-card').forEach(card => {
      const video = card.querySelector('video');
      if (!video || card.querySelector('.pp-lamp-play')) return;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'pp-lamp-play';
      button.setAttribute('aria-label', (card.querySelector('figcaption')?.textContent.trim() || 'Ürün') + ' videosunu oynat');
      button.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path fill="currentColor" d="M8 5v14l11-7Z"/></svg>';
      button.addEventListener('click', () => {
        document.querySelectorAll('.pp-lamp-card-video').forEach(other => { if (other !== video) other.pause(); });
        video.play().catch(() => { button.hidden = false; });
      });
      video.addEventListener('play', () => { button.hidden = true; });
      video.addEventListener('pause', () => { button.hidden = false; });
      video.addEventListener('ended', () => { button.hidden = false; });
      card.append(button);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
